export default Object.freeze({
    BidConfiguration: 0,
    BidSummary: 1,
    BidOverview: 2,
});
